import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReservationService } from "../services/ReservationService";
import Logo from "../components/Logo";
import BackButton from "../components/BackButton";
import { DateTime } from "luxon";

export default function ConfirmCancelReservation() {
  const [searchParams] = useSearchParams();
  const reservationId = searchParams.get("reservation");
  const navigate = useNavigate();
  const [reason, setReason] = useState("");
  const [colleagueRegistration, setColleagueRegistration] = useState("");
  const [success, setSuccess] = useState(false);
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const service = new ReservationService();

  useEffect(() => {
    if (!reservationId) {
      setError("Reserva não encontrada.");
      setLoading(false);
      return;
    }

    const fetchReservation = async () => {
      try {
        const data = await service.findOne(reservationId);
        if (!data) {
          setError("Reserva não encontrada.");
        } else {
          setReservation(data);
        }
      } catch (err) {
        setError("Erro ao carregar reserva.");
      } finally {
        setLoading(false);
      }
    };

    fetchReservation();
  }, [reservationId]);

  const handleCancel = async () => {
    if (!reason.trim()) {
      alert("Por favor, informe um motivo para o cancelamento.");
      return;
    }
    try {
      const { blocked } = await service.cancelReservation(
        reservationId,
        reason,
        colleagueRegistration
      );
      setSuccess(true);
      if (blocked) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("name");
        localStorage.removeItem("isMaster");
        localStorage.removeItem("roleName");
        localStorage.removeItem("roleType");
      }
    } catch (error) {
      alert(error?.message || "Erro ao cancelar reserva. Tente novamente.");
    }
  };

  if (success) {
    return (
      <div className="container text-center p-5">
        <Logo center size="125px" className="mb-4" />
        <h1 className="fw-bold text-uppercase">
          Reserva Cancelada com Sucesso!
        </h1>
        <button
          className="btn btn-primary mt-4 btn-lg"
          onClick={() => navigate("/")}
        >
          OK
        </button>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="text-center p-5">
        <h2>Carregando...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center p-5">
        <BackButton />
        <h2 className="text-danger">{error}</h2>
      </div>
    );
  }

  const formattedDate = DateTime.fromISO(reservation.startHour, { zone: "UTC" })
    .setZone("America/Sao_Paulo")
    .toFormat("dd/MM/yyyy 'às' HH:mm");

  return (
    <div className="container p-5">
      <div
        className="d-flex align-items-center justify-content-center position-relative"
        style={{ height: "125px" }}
      >
        <BackButton />
        <Logo center className="mb-4" size="125px" />
      </div>

      <h1 className="text-center text-uppercase fw-bold mb-4">
        Cancelar Reserva
      </h1>

      <div className="text-center mb-3 text-large">
        <div>{formattedDate}</div>
        <div>{reservation.school?.name}</div>
      </div>

      <div className="mb-3 text-center">
        <label className="fw-bold d-block">Justificativa</label>
        <textarea
          className="form-control mx-auto"
          style={{ maxWidth: "400px", textAlign: "center" }}
          rows="4"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        ></textarea>
      </div>

      {/* <div className="mb-3 text-center">
        <label className="fw-bold d-block">Matrícula Colega</label>
        <input
          type="text"
          className="form-control mx-auto"
          style={{ maxWidth: "400px", textAlign: "center" }}
          value={colleagueRegistration}
          onChange={(e) => setColleagueRegistration(e.target.value)}
          placeholder="Digite a matrícula de um colega para notifica-lo sobre a disponibilidade dessa reserva"
        />
      </div> */}

      <div className="text-center text-muted">
        <strong>Aviso:</strong>
        <br />
        Cancelamento em excesso implica em sanções conforme Termo de Serviço.
      </div>

      <div className="text-center mt-4">
        <button
          className="btn btn-primary me-3 btn-lg"
          onClick={() => navigate(-1)}
        >
          Voltar
        </button>
        <button className="btn btn-danger btn-lg" onClick={handleCancel}>
          Cancelar Reserva
        </button>
      </div>
    </div>
  );
}
